import React, { Component } from "react";
import DOMPurify from "dompurify";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import AccountWidget from "../../components/shared/AccountWidget";
import styles from "../../thema/style";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import classes from "../../thema/style";
import { trackPurchase } from "../../utils/analytics";
import { FETCH_POST } from "../../config";
import { emptyCart } from "../../store/actions/cart";

class CheckoutSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: null,
      loading: true,
      error: null,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);

    // Sipariş başarılı, checkout form verilerini temizle
    localStorage.removeItem("checkout_form_data");

    // Önce location.state'ten sipariş bilgisini kontrol et (Havale/EFT için)
    if (this.props.location.state && this.props.location.state.order) {
      this.setState({
        order: this.props.location.state.order,
        loading: false,
      });
      trackPurchase(this.props.location.state.order);
      return;
    }

    // PayTR'den gelen merchant_oid parametresini kontrol et
    const urlParams = new URLSearchParams(this.props.location.search);
    let merchant_oid = urlParams.get("merchant_oid");

    // URL'de yoksa localStorage'tan al
    if (!merchant_oid) {
      merchant_oid = localStorage.getItem("paytr_merchant_oid");
    }

    if (merchant_oid) {
      try {
        // GraphQL mutation ile sipariş oluştur/al - GENİŞLETİLMİŞ QUERY (DÜZELTME)
        const query =
          "mutation($merchant_oid: String!) { completePaytrPayment(merchant_oid: $merchant_oid) { id c_number customer { id full_name email } email first_name last_name city town phone address invoice_address { invoice_first_name invoice_last_name invoice_type invoice_title tax_office tax_number address city town phone email } products { product { id name slug image } quantity price } comment shipping_cost total_price discount customer_discount payment status paytr_merchant_oid is_guest created_at } }";
        const variables = JSON.stringify({ merchant_oid: merchant_oid });

        const result = await FETCH_POST({ query: query, variables: variables });

        if (result.data.errors) {
          console.error("[Success] GraphQL error:", result.data.errors);
          this.setState({
            error: "Sipariş bilgisi alınamadı",
            loading: false,
          });
        } else {
          const order = result.data.data.completePaytrPayment;

          // localStorage'u temizle
          localStorage.removeItem("paytr_merchant_oid");

          // Sepeti temizle
          this.props.emptyCart();

          this.setState({
            order: order,
            loading: false,
          });

          trackPurchase(order);
        }
      } catch (error) {
        console.error("[Success] Catch bloğunda hata:", error);
        this.setState({
          error: "Bir hata oluştu: " + error.message,
          loading: false,
        });
      }
    } else {
      console.warn(
        "[Success] merchant_oid bulunamadı! URL ve localStorage boş.",
      );

      // Hiçbir sipariş bilgisi yok, anasayfaya yönlendir
      this.props.history.push({ pathname: "/" });
    }
  }

  paymentMethodValueToKey(method) {
    switch (method) {
      case "Kapıda Ödeme":
        return "payAtDoor";
      case "Havale / EFT":
        return "transfer";
      case "Online Ödeme":
        return "online";
      default:
        return null;
    }
  }

  render() {
    const { order, loading, error } = this.state;

    if (loading) {
      return (
        <div
          className="container"
          style={{ marginTop: 50, textAlign: "center" }}
        >
          <h3>Sipariş bilgisi yükleniyor...</h3>
          <p style={{ marginTop: 15, color: "#666" }}>
            Lütfen bekleyiniz, sipariş bilgileriniz getiriliyor...
          </p>
        </div>
      );
    }

    if (error) {
      return (
        <div
          className="container"
          style={{ marginTop: 50, textAlign: "center" }}
        >
          <h3 style={{ color: "#dc3545" }}>{error}</h3>
          <p style={{ marginTop: 15, color: "#666" }}>
            Sipariş bilgileriniz email adresinize gönderilmiştir. Lütfen email
            kutunuzu kontrol ediniz.
          </p>
          <Link to="/" className="btn btn-primary" style={{ marginTop: 20 }}>
            Anasayfaya Dön
          </Link>
        </div>
      );
    }

    if (!order) {
      console.warn("[Success] RENDER - Order null, fallback gösteriliyor");
      return (
        <div
          className="container"
          style={{ marginTop: 50, textAlign: "center" }}
        >
          <h3>Sipariş Bilgisi Bulunamadı</h3>
          <p style={{ marginTop: 15, color: "#666" }}>
            Sipariş bilgileriniz email adresinize gönderilmiştir. Lütfen email
            kutunuzu kontrol ediniz.
          </p>
          <p style={{ marginTop: 10, fontSize: 14, color: "#888" }}>
            Sorun devam ederse lütfen müşteri hizmetleri ile iletişime geçiniz.
          </p>
          <Link to="/" className="btn btn-primary" style={{ marginTop: 20 }}>
            Anasayfaya Dön
          </Link>
        </div>
      );
    }

    return (
      <React.Fragment>
        <PageTitle title={"Sipariş Başarılı"} />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9 mb-5"}>
                <div
                  style={{
                    padding: "40px 20px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: 8,
                    marginTop: 20,
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: 30 }}>
                    <div
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        backgroundColor: "#28a745",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <i
                        className="fas fa-check"
                        style={{ fontSize: 40, color: "white" }}
                      ></i>
                    </div>
                    <h2 style={{ marginBottom: 10, fontWeight: "bold" }}>
                      Siparişiniz için teşekkür ederiz!
                    </h2>
                  </div>

                  <div
                    style={{
                      backgroundColor: "white",
                      padding: 30,
                      borderRadius: 8,
                      marginBottom: 20,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        marginBottom: 25,
                        lineHeight: 1.6,
                      }}
                    >
                      Sevgili{" "}
                      <strong>
                        {(order.first_name && order.last_name
                          ? order.first_name + " " + order.last_name
                          : null) ||
                          (order.customer && order.customer.full_name) ||
                          order.email}
                      </strong>
                      , siparişiniz bize ulaşmıştır.{" "}
                      {order.payment === "Havale / EFT" ? (
                        <span>
                          Ödemenizin hesabımıza ulaşması sonrasında siparişiniz
                          kargoya verilecektir.{" "}
                          <strong>
                            Ödemenin 7 gün içinde yapılması gerekmektedir, aksi
                            takdirde siparişiniz otomatik olarak iptal
                            edilecektir.
                          </strong>{" "}
                          Ödeme bilgileriniz e-posta adresinize gönderilmiştir.
                        </span>
                      ) : (
                        <span>
                          Siparişiniz kargoya verildiğinde sizi e-posta ile
                          bilgilendireceğiz.
                        </span>
                      )}
                    </p>

                    <div
                      style={{ borderTop: "1px solid #dee2e6", paddingTop: 20 }}
                    >
                      <div style={{ marginBottom: 15 }}>
                        <span style={{ color: "#6c757d", fontSize: 14 }}>
                          Sipariş No:{" "}
                        </span>
                        <strong style={{ fontSize: 18, color: "#333" }}>
                          {order.c_number}
                        </strong>
                      </div>

                      <div style={{ marginBottom: 15 }}>
                        <span style={{ color: "#6c757d", fontSize: 14 }}>
                          Sipariş Tarihi:{" "}
                        </span>
                        <strong style={{ fontSize: 16 }}>
                          {order.created_at
                            ? new Date(order.created_at).toLocaleDateString(
                                "tr-TR",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )
                            : ""}
                        </strong>
                      </div>

                      <div style={{ marginBottom: 15 }}>
                        <span style={{ color: "#6c757d", fontSize: 14 }}>
                          Sipariş Tutarı:{" "}
                        </span>
                        <strong style={{ fontSize: 18, color: "#28a745" }}>
                          {parseFloat(order.total_price).toFixed(2)} ₺
                        </strong>
                        <span
                          style={{
                            color: "#6c757d",
                            fontSize: 14,
                            marginLeft: 10,
                          }}
                        >
                          /{" "}
                          {order.products &&
                            order.products.reduce(function (total, item) {
                              return total + (item.quantity || 0);
                            }, 0)}{" "}
                          ürün
                        </span>
                      </div>
                    </div>
                  </div>

                  {this.props.setting &&
                    this.props.setting.setting &&
                    this.props.setting.setting.payments &&
                    this.props.setting.setting.payments.find(
                      function (item) {
                        return (
                          item.method ===
                          this.paymentMethodValueToKey(order.payment)
                        );
                      }.bind(this),
                    ) && (
                      <div
                        style={{
                          backgroundColor: "#fff8e2ff",
                          padding: 20,
                          borderRadius: 8,

                          marginBottom: 20,
                        }}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            this.props.setting.setting.payments
                              .find(
                                function (item) {
                                  return (
                                    item.method ===
                                    this.paymentMethodValueToKey(order.payment)
                                  );
                                }.bind(this),
                              )
                              .successMessage.replace(
                                /{{orderid}}/g,
                                order.c_number,
                              )
                              .replace(
                                /{{total_price}}/g,
                                parseFloat(order.total_price).toFixed(2),
                              )
                          ),
                        }}
                      />
                    )}

                  <div style={{ textAlign: "center", marginTop: 30 }}>
                    <Link
                      to="/"
                      className="btn btn-success"
                      style={{ padding: "12px 40px", fontSize: 16 }}
                    >
                      Anasayfaya Dön
                    </Link>
                    {(order.customer ||
                      (!order.is_guest && order.is_guest !== undefined)) && (
                      <Link
                        to="/hesabim/siparislerim"
                        className="btn btn-success"
                        style={{
                          padding: "12px 40px",
                          fontSize: 16,
                          marginLeft: 10,
                        }}
                      >
                        Siparişlerim
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className={"col-md-3"}>
                <AccountWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting }) => {
  return { setting };
};

const mapDispatchToProps = {
  emptyCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccess);



// WEBPACK FOOTER //
// ./src/routers/Checkout/success.js